import { NICHES } from "./niches";
import { NICHE_LANDING_PAGES } from "./nicheLandingPages";

/** Primary niches shown as single pills in the dashboard picker. */
const PRIMARY_NICHE_IDS = [
    NICHES.HEALTHCARE.id,
    NICHES.BEAUTY_WELLNESS.id,
    NICHES.FITNESS_WELLNESS.id,
    NICHES.HOSPITALITY_FOOD.id,
];

export const NICHE_PICKER_PRIMARY = NICHE_LANDING_PAGES.filter((page) =>
    PRIMARY_NICHE_IDS.includes(page.id)
);

/**
 * Granular picker labels for professional-home-services.
 * All options resolve to the same niche id and landing path.
 *
 * @typedef {{ nicheId: string, label: string, icon: string, path: string }} NichePickerSubOption
 */

/** @type {NichePickerSubOption[]} */
export const NICHE_PICKER_PROFESSIONAL_OPTIONS = [
    {
        nicheId: NICHES.PROFESSIONAL_HOME_SERVICES.id,
        label: "Legal & Accounting",
        icon: "bi-briefcase",
        path: NICHES.PROFESSIONAL_HOME_SERVICES.path,
    },
    {
        nicheId: NICHES.PROFESSIONAL_HOME_SERVICES.id,
        label: "Contractors & Trades",
        icon: "bi-tools",
        path: NICHES.PROFESSIONAL_HOME_SERVICES.path,
    },
    {
        nicheId: NICHES.PROFESSIONAL_HOME_SERVICES.id,
        label: "Real Estate",
        icon: "bi-building",
        path: NICHES.PROFESSIONAL_HOME_SERVICES.path,
    },
    {
        nicheId: NICHES.PROFESSIONAL_HOME_SERVICES.id,
        label: "Auto & Insurance",
        icon: "bi-car-front",
        path: NICHES.PROFESSIONAL_HOME_SERVICES.path,
    },
];

/** Catch-all picker option — maps to creative-local. */
export const NICHE_PICKER_OTHER = {
    nicheId: NICHES.CREATIVE_LOCAL.id,
    label: "Other",
    icon: "bi-three-dots",
    path: NICHES.CREATIVE_LOCAL.path,
};
